<template>
    <div>
        <v-container class="grey lighten-5" fluid>
            <v-row v-if="details">
                <v-col cols="12">
                    <v-card>
                        <v-card-title>Cenniki usług dodatkowych: {{ details.company.name }}</v-card-title>
                        <v-card-text>
                            <v-form>
                                <v-row>
                                    <v-col cols="4">
                                        GPS
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="details.gps"
                                            class="pt-0"
                                            label="Cena"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="4">
                                    <v-switch v-model="details.gpsDay" label="Za każdy dzień?"/>
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                        Fotelik dziecięcy 0-13
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="details.childSeat0"
                                            class="pt-0"
                                            label="Cena"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="4">
                                    <v-switch v-model="details.childSeat0Day" label="Za każdy dzień?"/>
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                        Fotelik dziecięcy 9-18
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="details.childSeat9"
                                            class="pt-0"
                                            label="Cena"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="4">
                                    <v-switch v-model="details.childSeat9Day" label="Za każdy dzień?"/>
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                        Fotelik dziecięcy 18-36
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="details.childSeat18"
                                            class="pt-0"
                                            label="Cena"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="4">
                                    <v-switch v-model="details.childSeat18Day" label="Za każdy dzień?"/>
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                        Dodatkowy kierowca
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="details.driver"
                                            class="pt-0"
                                            label="Cena"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="4">
                                    <v-switch v-model="details.driverDay" label="Za każdy dzień?"/>
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                      Zwrot zabrudzonego auta
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="details.backDirty"
                                            class="pt-0"
                                            label="Cena"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="4">
                                    <v-switch v-model="details.backDirtyDay" label="Za każdy dzień?"/>
                                  </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="4">
                                      Wyjazd za granicę (kraje UE)
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field
                                            v-model="details.abroad"
                                            class="pt-0"
                                            label="Cena"
                                            type="number"
                                        ></v-text-field>
                                    </v-col>
                                  <v-col cols="4">
                                    <v-switch v-model="details.abroadDay" label="Za każdy dzień?"/>
                                  </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn
                                @click="save"
                            >
                                Zapisz
                                <v-icon size="24" right>
                                    mdi-content-save-outline
                                </v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <modal-loader :show="loading"/>
    </div>
</template>

<script>
import api from '../services/api';
import humanFileSize from '../mixins/humanFileSize';
import formatters from "@/mixins/formatters";
import permissions from "@/mixins/permissions";
import ModalLoader from "../components/ModalLoader";

export default {
    components: {
        ModalLoader,
    },
    mixins: [
        formatters,
        humanFileSize,
        permissions,
    ],
    savedCategoryDetails: null,
    props: ['id'],
    data() {
        return {
            loading: false,
            loadingDetails: false,
            loadingServices: false,
            loadingFields: false,
            details: null,
        }
    },
    methods: {
      async save() {
        const data = {
          ...this.details,
          gps: this.details.gps ? Number.parseInt(this.details.gps) : null,
          childSeat0: this.details.childSeat0
              ? Number.parseInt(this.details.childSeat0)
              : null,
          childSeat9: this.details.childSeat9
              ? Number.parseInt(this.details.childSeat9)
              : null,
          childSeat18: this.details.childSeat18
              ? Number.parseInt(this.details.childSeat18)
              : null,
          driver: this.details.driver
              ? Number.parseInt(this.details.driver)
              : null,
          backDirty: this.details.backDirty
              ? Number.parseInt(this.details.backDirty)
              : null,
          abroad: this.details.abroad
              ? Number.parseInt(this.details.abroad)
              : null,
        }

        await api.put(`/api/price-lists/additional/${this.id}`, data);
        this.$root.$emit('notifySuccess', {
          html: 'Cennik usług dodatkowych został zapisany.',
        });
      },
        async loadDetails() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;

            let response;

            try {
                response = await api.get(`/api/price-lists/additional/${this.id}`);
            } catch (error) {
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się wczytać danych kategorii.',
                    error,
                });

                return;
            }

            this.loadingDetails = false;

            this.details = response.data;
        },
    },
    async created() {
        try {
            await this.loadDetails();
        } catch (e) {
            void (0);
        }
    },
    beforeRouteUpdate(to, from, next) {
        next(); // Update the URL in address bar.
        this.id = to.params.id; // Store new user id in the local variable.

        this.loadDetails();
    },
}
</script>

<style scoped>
</style>
